export default "__VITE_ASSET__0e226953__"